import React from 'react';
import { Divider, Grid, Typography } from '@mui/material';

export default function AboutPage(props: any) {
  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12}>
          <Typography variant='h4' mb={1}>
            About
          </Typography>
          <Divider />
        </Grid>
      </Grid>
    </>
  );
}
